<template>
    <div id="pinwheelContainer">
        <div id="pinwheel"></div>
    </div>
</template>

<script>

export default {
    name: 'Intro',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
        }
    },

    components: {
    },
    ready() {
    },
    methods: {
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
    }
}
</script>

<style lang="scss">
@import "../styles/variables.scss";
#pinwheelContainer {
    text-align: center;
}
#pinwheel {
    display: inline-block;
    width: 15vw;
    height: 15vw;
    border-radius: 8vw;
    background: $color-white;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url(../assets/static/pinwheel.svg);
    animation:spin 3s linear infinite;
}

</style>